export const NETWORK_MODES = [
  {
    value: 'online',
    text: 'Connexion réseau requise',
  },
  {
    value: 'offline',
    text: 'Hors ligne',
  },
];

export const SECURITY_CONTEXTS = [
  {
    value: 'none',
    text: 'Aucun',
  },
  {
    value: 'use',
    text: 'Contient du contenu personnalisé si authentifié',
  },
  {
    value: 'require',
    text: `Nécessite d'être authentifié`,
  },
];



// WEBPACK FOOTER //
// ./src/modules/catalog/constants/index.js